import { useState } from 'react'

export const useLightbox = () => {
  const [lightboxIndex, setLightboxIndex] = useState(-1)

  const open = (index: number) => {
    setLightboxIndex(index)
  }

  const close = () => {
    setLightboxIndex(-1)
  }

  return { lightboxIndex, open, close }
}
